import { render, staticRenderFns } from "./PolizasRHForm.vue?vue&type=template&id=475738d6&scoped=true&"
import script from "./PolizasRHForm.vue?vue&type=script&lang=js&"
export * from "./PolizasRHForm.vue?vue&type=script&lang=js&"
import style0 from "./PolizasRHForm.vue?vue&type=style&index=0&id=475738d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475738d6",
  null
  
)

export default component.exports